export default "__VITE_ASSET__QF0IC0fr__"